import { createSlice } from "@reduxjs/toolkit";

export const userRoleSlice = createSlice({
  name: "userRoleSlice",
  initialState: {
    userRole: [],
  },
  reducers: {
    setUserRole: (currentSlice, action) => {
      currentSlice.userRole = action.payload;
    },
  },
});

export const { setUserRole } = userRoleSlice.actions;
export const userRoleReducer = userRoleSlice.reducer;
